import useLocale from '~/hooks/useLocale'

import { getMarketName } from '~/utils/locales'

function useMarket(): string {
  const locale = useLocale()

  return getMarketName(locale)
}

export default useMarket
